const LEGACY_SPOT_ICON_PREFIX = '/spot_icons/';
const ANY_SPOT_ICON_MARKER = '/public/spot_icons/';

export const resolveIconUrl = (value) => {
  if (typeof value !== 'string') return '';
  const trimmed = value.trim();
  if (!trimmed) return '';
  if (trimmed.startsWith(LEGACY_SPOT_ICON_PREFIX)) {
    return trimmed; // Served locally from /public/spot_icons/ in each app
  }
  const markerIndex = trimmed.indexOf(ANY_SPOT_ICON_MARKER);
  if (markerIndex >= 0) {
    return trimmed; // S3 URL (pladdypusv2 or pladdypusv3), load from S3 directly
  }
  return trimmed;
};

export const isSpotIconUrl = (value) => {
  if (typeof value !== 'string') return false;
  const trimmed = value.trim();
  if (trimmed.startsWith(LEGACY_SPOT_ICON_PREFIX)) return true;
  return trimmed.includes(ANY_SPOT_ICON_MARKER);
};

export const resolveSidebarIconSrc = (item) => {
  if (!item) return '';
  const iconImage = resolveIconUrl(item.iconImage);
  if (iconImage) return iconImage;
  const bannerImage = resolveIconUrl(item.bannerImage);
  return isSpotIconUrl(bannerImage) ? bannerImage : '';
};
